export const limitsLengthRegistrationFields = {
  Company: 128
} as const;
